module.exports = __webpack_public_path__ + "img/gradient-triangle2.066cc26c.svg";